import React, { useState } from "react";
import styles from "./Menu.module.css";
import image from "../../assets/Avatar.png";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import Modal from "../UI/Modal";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../utils/store/redux-store/Index";

function Menu(props) {
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const vendorInfo = useSelector((data) => data.auth.vendorSignInData);

  const backHandler = () => {
    setModal(false);
    props.setShowMenu(false);
    dispatch(authActions.logOut());
    navigate("/login");
  };
  const proceedHandlerFinal = () => {
    setModal(false);
  };
  return (
    <div>
      {modal && (
        <Modal
          title="Logout?"
          message="You are about to logout."
          messageExtra="Are you sure you want to logout?"
          back="No"
          accept="Yes"
          close={proceedHandlerFinal}
          confirm={backHandler}
        />
      )}
      <div className={styles.menu__modal}>
        <div className={styles.menu__modal__inner}>
          <div className={styles.modal__header}>
            <div className={styles.wrapper}>
              <img src={image} alt="profile" />
            </div>
            <div>
              <h4>{vendorInfo[0]?.fullname}</h4>
              <p>{vendorInfo[0]?.email}</p>
            </div>
          </div>
          <div className={styles.menu__modal__list}>
            <NavLink
              to="/account"
              className={(navData) =>
                navData.isActive ? `${styles.active}` : ""
              }
            >
              <div>
                <div className={styles.svg}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 6C11.2583 6 10.5333 6.21993 9.91661 6.63199C9.29993 7.04404 8.81928 7.62971 8.53545 8.31494C8.25162 9.00016 8.17736 9.75416 8.32205 10.4816C8.46675 11.209 8.8239 11.8772 9.34835 12.4017C9.8728 12.9261 10.541 13.2833 11.2684 13.4279C11.9958 13.5726 12.7498 13.4984 13.4351 13.2145C14.1203 12.9307 14.706 12.4501 15.118 11.8334C15.5301 11.2167 15.75 10.4917 15.75 9.75C15.75 8.75544 15.3549 7.80161 14.6517 7.09835C13.9484 6.39509 12.9946 6 12 6ZM12 12C11.555 12 11.12 11.868 10.75 11.6208C10.38 11.3736 10.0916 11.0222 9.92127 10.611C9.75097 10.1999 9.70642 9.7475 9.79323 9.31105C9.88005 8.87459 10.0943 8.47368 10.409 8.15901C10.7237 7.84434 11.1246 7.63005 11.561 7.54323C11.9975 7.45642 12.4499 7.50097 12.861 7.67127C13.2722 7.84157 13.6236 8.12996 13.8708 8.49997C14.118 8.86998 14.25 9.30499 14.25 9.75C14.2494 10.3466 14.0122 10.9185 13.5903 11.3403C13.1685 11.7622 12.5966 11.9994 12 12Z"
                      fill="#008069"
                    />
                    <path
                      d="M12 1.5C9.9233 1.5 7.89323 2.11581 6.16651 3.26957C4.4398 4.42332 3.09398 6.0632 2.29926 7.98182C1.50454 9.90045 1.29661 12.0116 1.70175 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246C6.04383 20.8931 7.91475 21.8931 9.95155 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.4968 9.2162 21.3896 6.54733 19.4211 4.57889C17.4527 2.61044 14.7838 1.50318 12 1.5ZM7.5 19.7828V18.75C7.5006 18.1534 7.73784 17.5815 8.15967 17.1597C8.5815 16.7378 9.15345 16.5006 9.75 16.5H14.25C14.8466 16.5006 15.4185 16.7378 15.8403 17.1597C16.2622 17.5815 16.4994 18.1534 16.5 18.75V19.7828C15.1344 20.5802 13.5814 21.0004 12 21.0004C10.4186 21.0004 8.86562 20.5802 7.5 19.7828ZM17.994 18.6945C17.9791 17.7107 17.5782 16.7722 16.8779 16.0812C16.1776 15.3901 15.2339 15.0019 14.25 15H9.75C8.76614 15.0019 7.82238 15.3901 7.12207 16.0812C6.42175 16.7722 6.02095 17.7107 6.006 18.6945C4.64592 17.4801 3.6868 15.8812 3.25563 14.1095C2.82445 12.3378 2.94157 10.477 3.59148 8.77339C4.24138 7.06978 5.39341 5.60375 6.89503 4.56942C8.39664 3.5351 10.177 2.98127 12.0004 2.98127C13.8237 2.98127 15.6041 3.5351 17.1057 4.56942C18.6073 5.60375 19.7594 7.06978 20.4093 8.77339C21.0592 10.477 21.1763 12.3378 20.7451 14.1095C20.314 15.8812 19.3548 17.4801 17.9948 18.6945H17.994Z"
                      fill="#008069"
                    />
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>My Account</p>
                </div>
              </div>
            </NavLink>
            <NavLink
              to="/history"
              className={(navData) =>
                navData.isActive ? `${styles.active}` : ""
              }
            >
              <div>
                <div className={styles.svg}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2H12.25C12.4667 2 12.646 2.07067 12.788 2.212C12.9293 2.354 13 2.53333 13 2.75V10.275C13.3 10.4583 13.5417 10.6957 13.725 10.987C13.9083 11.279 14 11.6167 14 12C14 12.55 13.8043 13.0207 13.413 13.412C13.021 13.804 12.55 14 12 14C11.45 14 10.9793 13.804 10.588 13.412C10.196 13.0207 10 12.55 10 12C10 11.6167 10.0917 11.275 10.275 10.975C10.4583 10.675 10.7 10.4417 11 10.275V8.125C10.1333 8.35833 9.41667 8.829 8.85 9.537C8.28333 10.2457 8 11.0667 8 12C8 13.1 8.39167 14.0417 9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 11.6167 15.946 11.2373 15.838 10.862C15.7293 10.4873 15.5667 10.1333 15.35 9.8C15.2 9.56667 15.1377 9.33733 15.163 9.112C15.1877 8.88733 15.2833 8.69167 15.45 8.525C15.65 8.325 15.904 8.225 16.212 8.225C16.5207 8.225 16.7667 8.35833 16.95 8.625C17.3167 9.15833 17.5833 9.71233 17.75 10.287C17.9167 10.8623 18 11.4333 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18C10.3333 18 8.91667 17.4167 7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.5 6.475 9.196 7.425 8.088C8.375 6.97933 9.56667 6.30833 11 6.075V4.05C9.01667 4.3 7.35433 5.175 6.013 6.675C4.671 8.175 4 9.95 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.0167 19.8583 10.1333 19.575 9.35C19.2917 8.56667 18.8917 7.84167 18.375 7.175C18.1917 6.94167 18.1043 6.69167 18.113 6.425C18.121 6.15833 18.225 5.925 18.425 5.725C18.625 5.525 18.8627 5.425 19.138 5.425C19.4127 5.425 19.6333 5.53333 19.8 5.75C20.5 6.6 21.0417 7.54167 21.425 8.575C21.8083 9.60833 22 10.75 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
                      fill="#008069"
                    />
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>History</p>
                </div>
              </div>
            </NavLink>
            <div>
              <div className={styles.svg}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 18H13V6L8 8V13L4 15V7L13 3L20 5V18L13 21L4 18Z"
                    stroke="#008069"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className={styles.title}>
                <p>About us</p>
              </div>
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
                setModal(true);
              }}
            >
              <div className={styles.svg}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.5 22.5H13.5C13.8977 22.4996 14.279 22.3414 14.5602 22.0602C14.8414 21.779 14.9996 21.3977 15 21V18.75H13.5V21H4.5V3H13.5V5.25H15V3C14.9996 2.6023 14.8414 2.221 14.5602 1.93978C14.279 1.65856 13.8977 1.5004 13.5 1.5H4.5C4.1023 1.5004 3.721 1.65856 3.43978 1.93978C3.15856 2.221 3.0004 2.6023 3 3V21C3.0004 21.3977 3.15856 21.779 3.43978 22.0602C3.721 22.3414 4.1023 22.4996 4.5 22.5Z"
                    fill="#008069"
                  />
                  <path
                    d="M15.4395 15.4395L18.129 12.75H7.5V11.25H18.129L15.4395 8.5605L16.5 7.5L21 12L16.5 16.5L15.4395 15.4395Z"
                    fill="#008069"
                  />
                </svg>
              </div>
              <div className={styles.title}>
                <p>Logout</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
